import classNames from 'classnames';
import { type ReactNode, useRef } from 'react';

import { useDocumentPropertyHeightSetter } from '../../../common/hooks/useDocumentPropertyHeightSetter';

interface SearchInContentProps {
    searchSlot: ReactNode;
}

const HeaderSearch = (props: SearchInContentProps) => {
    const ref = useRef<HTMLDivElement>(null);
    useDocumentPropertyHeightSetter('--headerSearchHeight', ref);

    return (
        <div ref={ref} className={classNames('HeaderSearch')} data-test="searchHeader">
            {props.searchSlot && (
                <div role="search" className="HeaderSearchBar">
                    {props.searchSlot}
                </div>
            )}
        </div>
    );
};

export default HeaderSearch;
